import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const DatasetConvertToastError = ({ datasetName }) => (
  <div className="aridhia-error-toast toast-deleted toast-message">
    <Icon name="times circle" color="red" />
    <FormattedMessage id="dataset.convert.toast.update.dictionaries.error" values={{ datasetName }} />
  </div>
);

export default DatasetConvertToastError;
